import ProductsContainer from './ProductsContainer';
export default ProductsContainer;
